import { Fragment } from 'react/jsx-runtime';
import CourseTypeFilter from './CourseTypeFilter';
import { CarouselFilterProps } from './CarouselFilterProps';
import { ProjectsSections } from '../ProjectCarousel';
import ProjectPeriodFilter from './ProjectPeriodFilter';

type SectionFilterFactoryProps = {
  section?: ProjectsSections;
} & CarouselFilterProps;

const SectionFilterFactory = ({
  section,
  ...props
}: SectionFilterFactoryProps) => {
  const courseTypeSections: ProjectsSections[] = [
    'recents',
    'hackathon',
    'ranking',
  ];
  if (section && courseTypeSections.includes(section)) {
    return <CourseTypeFilter {...props} />;
  }

  if (section === 'me') {
    return <Fragment />;
  }
  if (section) {
    return <ProjectPeriodFilter {...props} />;
  }

  return <Fragment />;
};

export default SectionFilterFactory;
